/**
 * Service Desk Hub — single page with tabs for all service desk analytics.
 *
 * Tabs:
 * - Workload: per-analyst metrics, capacity, trends
 * - Onboarding: provisioning velocity, termination recovery
 * - Ticket Insights: anomaly detection, heatmaps, patterns
 */

import { useState } from 'react';
import { ServiceDeskWorkload } from './ServiceDeskWorkload';
import { OnboardingVelocity } from './OnboardingVelocity';
import { TicketInsights } from './TicketInsights';
import { StaffingModel } from './StaffingModel';

const TABS = [
  { id: 'workload', label: 'Workload' },
  { id: 'onboarding', label: 'Onboarding & Offboarding' },
  { id: 'staffing', label: 'Staffing Model' },
  { id: 'insights', label: 'Ticket Insights' },
] as const;

type TabId = typeof TABS[number]['id'];

export function ServiceDeskHub() {
  const [activeTab, setActiveTab] = useState<TabId>('workload');

  return (
    <div>
      {/* Tab Bar */}
      <div className="flex gap-1 border-b border-border mb-6">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.id
                ? 'border-baker-red text-baker-red'
                : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'workload' && <ServiceDeskWorkload />}
      {activeTab === 'onboarding' && <OnboardingVelocity />}
      {activeTab === 'staffing' && <StaffingModel />}
      {activeTab === 'insights' && <TicketInsights />}
    </div>
  );
}
